import React, { useState, useContext, useEffect } from 'react';
import ViewsContext from 'contexts/viewsContext';
import CostCenterChartGlance from './costCenterChartGlance';
import CostCenterTableViewGlance from './costCenterTableViewGlance';


export default function ToggleCostCenterGlance(props) {

    const { viewsState, setCostCenterToggleState } = useContext(ViewsContext);
    const [chartToggleClass, setChartToggleClass] = useState('');
    const [tableViewToggleClass, setTableViewToggleClass] = useState('');

    useEffect(() => {
        if (viewsState.chartsAndTableViewsConfigs.costCenterToggleState === 'chart') {
            setTableViewToggleClass('togglable-hidden');
            setChartToggleClass('');
        }
        else if (viewsState.chartsAndTableViewsConfigs.costCenterToggleState === 'tableView') {
            setChartToggleClass('togglable-hidden');
            setTableViewToggleClass('');
        }

    }, [viewsState]);

    const changeView = () => {
        if (viewsState.chartsAndTableViewsConfigs.costCenterToggleState === 'chart') {
            setCostCenterToggleState('tableView');
        }
        else if (viewsState.chartsAndTableViewsConfigs.costCenterToggleState === 'tableView') {
            setCostCenterToggleState('chart');
        }
    };

    if (viewsState.chartsAndTableViewsConfigs.costCenterToggleState === 'chart') {
        return (
            <>
                <div className='glance-holder col-12  col-md-6'>
                    <CostCenterChartGlance data={props.data} viewState={chartToggleClass} changeViewStateFn={changeView} />
                </div>
            </>
        );
    }
    else {
        return (
            <>
                <div className='glance-holder col-12  col-md-6'>
                    <CostCenterTableViewGlance data={props.data} viewState={tableViewToggleClass} changeViewStateFn={changeView} />
                </div>
            </>
        );
    }

}

